import React from 'react';
import ChartsIndex from '@/pages/intelligence/components/ChartsComponents/ChartsIndex';
import { ChartType } from '@/pages/intelligence/pages/TopCharts/_config/enums';
import useLineCharts from '@/pages/intelligence/components/Chart/hooks/useLineCharts';
import useIntlExtend from '@/pages/intelligence/hooks/useIntlExtend';

interface ICompareVisualis {
  lineData: any;
  dateType: string;
  isPercentage: boolean;
  isAlignToRelease?: boolean;
  metricText?: React.ReactNode;
  chartType?: ChartType;
  chartLoading?: boolean;
  colors?: string[];
}

// 每个榜单，组装好各类可视化需要的数据，传递给可视化统一组件
const CompareVisualis: React.FC<ICompareVisualis> = ({
  lineData: metricLineData,
  dateType,
  isAlignToRelease,
  metricText,
  isPercentage,
  chartLoading = false,
  colors,
}) => {
  const { formatMessage } = useIntlExtend();

  // 获取折线图hooks
  const { lineOption } = useLineCharts({
    colors,
    metric: 'source',
    lineData: { source: metricLineData },
    xAxisAutoSort: false,
    imageType: 'compare',
    topChartsType: 'pcMetricsTable',
    titleNow: metricText,
    // 控制 tooltip 左上角时间显示，alignToRelease 时直接展示 x 轴 label
    dateType: isAlignToRelease ? '' : dateType,
    // 是否为百分比指标折线图
    isPercentLine: isPercentage,
    // Tooltip 内容超出时出现滚动条并允许鼠标移入
    tooltip: {
      // 鼠标可以移入 tooltip
      enterable: true,
      backgroundColor: 'rgba(0, 0, 0, 0)',
      // 设置滚动样式，调整 max-height 以控制高度
      // extraCssText: 'padding: 6px; background: #262832;',
    },
  });

  return (
    <div className="card-line">
      <ChartsIndex
        // ref={chartsInstance}
        chartType={ChartType.Line}
        // 元素高度
        echartHight={316}
        // 图表渲染高度
        chartHeight={316}
        // 折线图配置
        lineOption={lineOption}
        chartLoading={chartLoading}
        // 无数据空态文案
        isNodata={!metricLineData?.length}
        nodataMsg={`<div class="dbi-nodata-message">
                    ${formatMessage({ id: 'dbi_info_allMetrics_nodata_msg_new' })}
                  </div>`}
      />
    </div>
  );
};

export default CompareVisualis;
